import { render } from "./role-auth.vue?vue&type=template&id=0b739630"
import script from "./role-auth.vue?vue&type=script&lang=js"
export * from "./role-auth.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__